import '~/js/modules/bootstrap-tabs';
//alert('test');
const callingCodesObj = require('~/js/modules/countryCallingCodes');

// create new array for countries and appending a new object that represents default value
const countries = [
    {
        name: 'Select A Country',
        id: '',
        regionCode: '',
        code: ''
    },
    ...window.beaches_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [...window.beaches_app.page.states];

const beachesResorts = window.beaches_app.page.resorts;

// react form elements contact
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';
import DepartmentSelect from '~/js/components/general/DepartmentSelect';

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="country"
        stateName="state"
        stateLabelWrapper="lg-4"
        stateInputWrapper="lg-8"
        countryLabelWrapper="lg-4"
        countryInputWrapper="lg-8"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <CustomDatePicker
        name="weddingDate"
        wrapperClassName="xs-12"
        inputClassName="hidden-validation wedding-date-input"
        displayStringDate={false}
        isRequired
    />,
    document.getElementById('wedding-datepicker')
);
ReactDOM.render(
    <CustomDatePicker
        name="departureDate"
        wrapperClassName="xs-12"
        inputClassName="departure-date-input"
        displayStringDate={false}
        isRequired
    />,
    document.getElementById('departure-Date')
);
//end CustomDatePicker

ReactDOM.render(
    <CustomTextarea
        name="callbackmessage"
        id="callbackmessage"
        maxLength="4000"
        displayCharacterCount
        isRequired
    />,
    document.getElementById('react-textarea-callback')
);

ReactDOM.render(
    <CustomTextarea
        name="message"
        id="message"
        maxLength="4000"
        displayCharacterCount
        isRequired
    />,
    document.getElementById('react-textarea')
);

ReactDOM.render(
    <CustomRecaptcha wrapperClassName="xs-12" />,
    document.getElementById('google-recaptcha')
);

ReactDOM.render(
    <DepartmentSelect resorts={beachesResorts} />,
    document.getElementById('department-dropdown')
);

// form validations
import '~/js/modules/fend';

// Form Validation
$('.contact-form').fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        city: 'lettersOnly'
    }
});
// request call back Form Validation
$('.request-call-back-form').fend({
    rules: {
        clientName: 'lettersOnly',
        phoneNumber:'alphanumeric'
    }
});
// form elements references
const $weddingDateRow = $('.wedding-date-row');
const $weddingDateInput = $('.wedding-date-input');
const $countrySelector = $('select[name="country"]');
const $tabContainer = $('#desktop-tabs');
const $tabSelector = $('#js-tab-select');
const $subscribeLabel = $('.form-label[for="subscribe"]');
const $departureDate = $('.departure-date-input');
// const $landlineNumber = $('#landLineNumber');
// const $mobileNumber = $('#mobileNumber');
// const $validPhone = $('#contactNumberValid');

// select functionality
$tabSelector.change(function toggleTabs() {
    $('.tab-pane').hide();
    $('#' + $(this).val()).show();
    $('.active').removeClass('active');
    $('#' + $(this).val()).addClass('active');
    $('#tab-' + $(this).val()).addClass('active');
    $('.tab-' + $(this).val()).addClass('active');
});

$tabContainer.on('click', '.tab', event => {
    const $tabValue = $(event.currentTarget)
        .find('.tab-link')
        .data('value');

    $tabSelector.val($tabValue);
});

// mobile number validation at least one must be required
// $landlineNumber.change(function validateNumber() {
//     if (this.value) {
//         $mobileNumber.removeAttr('required');
//         $mobileNumber.trigger('blur');
//     } else {
//         $mobileNumber.attr('required', true);
//     }
// });

// $mobileNumber.change(function validateNumber() {
//     if (this.value) {
//         $landlineNumber.removeAttr('required');
//         $landlineNumber.trigger('blur');
//     } else {
//         $landlineNumber.attr('required', true);
//     }
// });

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', event => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));
    $('.contact-uk-verbage').show();
    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
        $('.contact-uk-verbage').hide();
    }
});

// display wedding date
$('[name="planningWedding"]').on('change', event => {
    const $selectedValue = event.target.value;

    if ($selectedValue === 'true') {
        $weddingDateRow.slideDown('fast');
        $weddingDateInput.removeClass('hidden-validation');
    } else {
        $weddingDateRow.slideUp('fast');
        $weddingDateInput.addClass('hidden-validation');
    }
});

$(document).ready(() => {
    // if ($landlineNumber.val()) {
    //     $mobileNumber.removeAttr('required');
    //     $mobileNumber.trigger('blur');
    // }

    // if ($mobileNumber.val()) {
    //     $landlineNumber.removeAttr('required');
    //     $landlineNumber.trigger('blur');
    // }

    //FOR COUNTRY CODE
  $('[name=country]').on('change', function() {
        const selectedCountry = $(this).val();

        callingCodesObj.countryCodes.map(function(index) {
            if (selectedCountry === index.code) {
                $('span.countryCode').html(index.dial_code);
            }
        });
    });
});

// document.getElementById('wantToBeCalled').onchange = e => {
//     const contactInfo = document.getElementById('contact-info');

//     if (e.target.value === 'true') {
//         contactInfo.style.maxHeight = contactInfo.scrollHeight + 56 + 'px';
//         $('#landLineNumber').prop('required', true);
//         $('#mobileNumber').prop('required', true);
//         $('#bestTimeToCall').prop('required', true);
//         $('#timezone').prop('required', true);
//     } else {
//         contactInfo.style.maxHeight = null;
//         $('#landLineNumber').removeAttr('required');
//         $('#mobileNumber').removeAttr('required');
//         $('#bestTimeToCall').removeAttr('required');
//         $('#timezone').removeAttr('required');
//     }
// };
$(function(){
    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');
  
    $('.nav-tabs a').click(function (e) {
      $(this).tab('show');
      var scrollmem = $('body').scrollTop();
      window.location.hash = this.hash;
      $('html,body').scrollTop(scrollmem);
    });
  });

  document.getElementById('js-tab-select').addEventListener('change', function() {
    var pressVal = document.getElementById('js-tab-select').value;
    console.log(pressVal)
       if(pressVal === 'contact-press-team') {
           window.open('https://news.beaches.co.uk/press_contacts/','_blank');
        }
  });